import { green } from '@mui/material/colors';

const style = {
  // Estilos modernos con spacing consistente
  paper: {
    marginTop: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 3,
    borderRadius: 2,
  },
  
  form: {
    login: { 
      width: { xs: '95%', sm: '80%', md: '35%' }, 
      marginTop: 3,
    },
    width: { xs: '95%', sm: '80%', md: '60%' },
    marginTop: 2,
  },
  
  avatar: {
    margin: 2,
    backgroundColor: '#1976d2',
    width: 80,
    height: 80,
    boxShadow: '0 4px 14px 0 rgba(25,118,210,0.39)',
  },
  
  avatarmenu: {
    margin: 2,
    backgroundColor: '#1976d2',
    width: 80,
    height: 80,
    boxShadow: '0 4px 14px 0 rgba(25,118,210,0.39)',
  },
  
  icon: {
    fontSize: 40,
    color: 'primary.main',
  },
  
  submit: {
    width: '100%',
    py: 1.5,
    mt: 3,
    mb: 2,
    borderRadius: 2,
    fontWeight: 600,
    boxShadow: '0 4px 14px 0 rgba(25,118,210,0.39)',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(25,118,210,0.5)',
      transform: 'translateY(-2px)',
    },
  },
  
  TextField: {
    width: { xs: '100%', sm: 300 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  TextFieldbuscar: {
    marginLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  iconbuscar: {
    marginTop: 2,
  },
  
  timer: {
    width: '95%',
    paddingLeft: 2,
    marginBottom: 2,
  },
  
  textTel: {
    marginTop: 1,
    width: { xs: '100%', sm: 200 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  textDet: {
    marginTop: 1,
    width: { xs: '100%', sm: 280 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  btnTel: {
    marginTop: 2,
    marginLeft: 1,
    borderRadius: 2,
    fontWeight: 600,
  },
  
  SelectDi: {
    width: { xs: '100%', sm: 260 },
    marginTop: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  Selecttel: {
    width: { xs: '100%', sm: 190 },
    marginTop: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  typo: {
    color: green[500],
    fontWeight: 600,
  },
  
  typocard: {
    paddingLeft: 7,
    marginTop: 1,
  },
  
  iconBar: {
    marginRight: 12,
  },
  
  Select: {
    tareausuario: {
      marginTop: 2,
      width: { xs: '100%', sm: 260 },
      paddingLeft: 2,
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      },
    },
    tareatipotarea: {
      width: '96%',
      marginTop: 2,
      paddingLeft: 2,
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      },
    },
    rol: {
      width: '100%',
      marginTop: 2,
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      },
    },
    width: { xs: '100%', sm: 260 },
    paddingLeft: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  Selectrol: {
    width: { xs: '100%', sm: 290 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  Select2: {
    Campana: {
      width: '100%',
      marginTop: 2,
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      },
    },
    width: { xs: '100%', sm: 260 },
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  textTarea: {
    pre: {
      marginTop: 2,
      width: '96%',
      paddingLeft: 2,
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
      },
    },
    width: '90%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  textarea: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
    },
  },
  
  table: {
    presasi: {
      width: '100%',
      marginTop: 2,
      '& .MuiTableHead-root': {
        backgroundColor: '#f5f7fa',
      },
      '& .MuiTableCell-head': {
        fontWeight: 700,
        color: '#212121',
      },
    },
    contpresasi: {
      width: '104%',
    },
    tareas: {
      width: '100%',
      '& .MuiTableHead-root': {
        backgroundColor: '#f5f7fa',
      },
      '& .MuiTableCell-head': {
        fontWeight: 700,
        color: '#212121',
      },
    },
    width: { xs: '100%', lg: '70%' },
    paddingLeft: { lg: 31 },
    marginTop: 2,
    '& .MuiTableHead-root': {
      backgroundColor: '#f5f7fa',
    },
    '& .MuiTableCell-head': {
      fontWeight: 700,
      color: '#212121',
    },
  },
  
  // Estilos adicionales para cards modernos
  card: {
    borderRadius: 3,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
      transform: 'translateY(-2px)',
    },
  },
  
  cardHeader: {
    backgroundColor: 'primary.main',
    color: 'white',
    fontWeight: 600,
  },
  
  // Botones modernos
  buttonPrimary: {
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1.5,
    boxShadow: '0 4px 14px 0 rgba(25,118,210,0.39)',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(25,118,210,0.5)',
      transform: 'translateY(-2px)',
    },
  },
  
  buttonSecondary: {
    borderRadius: 2,
    textTransform: 'none',
    fontWeight: 600,
    px: 3,
    py: 1.5,
  },
  
  // Badges modernos
  badge: {
    '& .MuiBadge-badge': {
      fontWeight: 600,
      fontSize: '0.75rem',
    },
  },
};

export default style;
